import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import React from "react";
import PropTypes from "prop-types";
import GoogleSuggestionList from "../GoogleSuggestionList/index.js";
import LocalSuggestionList from "../LocalSuggestionList/index.js";
import { DATA_SOURCES } from "../../constants/index.js";

var DefaultSuggestionList = function DefaultSuggestionList(_ref) {
  var source = _ref.source,
      rest = _objectWithoutProperties(_ref, ["source"]);

  if (source === DATA_SOURCES.LOCAL) {
    return React.createElement(LocalSuggestionList, rest);
  } else if (source === DATA_SOURCES.GOOGLE) {
    return React.createElement(GoogleSuggestionList, rest);
  }

  return null;
};

process.env.NODE_ENV !== "production" ? DefaultSuggestionList.propTypes = {
  source: PropTypes.oneOf([DATA_SOURCES.LOCAL, DATA_SOURCES.GOOGLE])
} : void 0;
export default DefaultSuggestionList;